import React from 'react';
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import Icon from '@mdi/react';
import { mdiCannabis } from '@mdi/js';

const Landing = () => {
  return (

    <div>

      {/* < !--==================== MAIN ==================== --> */}
      <main className="main" id="main__section-id">

        <div className="hero__container">
          <Zoom top duration={5000}>
            <img className="hero" src="images/hero.png" alt="" />
          </Zoom>
        </div>


        {/* <!--==================== ABOUT SECTION ====================--> */}

        <section className="about__section" id="about__section-id">

          <div className="section_heading-cloud bounce center" id="about">
            <img src="images/aboutCloud.png" alt=" a floating cloud of text that says about" />
          </div>

          <div className="about__container">

            <img className="cloud-border cloud-border--top" src="images/cloud_border.png" alt="a cloud that borders the following text" />
            <img className="cloud-border cloud-border-long--top" src="images/cloud_border-long.png" alt="a cloud that borders the following text" />

            <div className="copy__container">

              <div className="about__copy">
                <h1>The Little Stonies Story</h1>
                <p>We are Little Stonies, a collection of 4,200 characters based around herb that wants to bridge the gap between the Cannabis Industry and Web3. To do this, we are creating a DAO that allows our NFT holders to vote on where we dispense our product through the purchase of Smart Vending Machines that are stocked with herb and all the essential items our customers need. Our vision is to tap into a new market and position ourselves as the most diversified choice for herb dispensing.</p>

                <br />

                <p>In addition to this, we are introducing a staking mechanism that allows you to stake your genesis NFT in order to yield a set number of $STNIE per day per stake. These tokens can then be used to acquire our *classified* sub-collection. We believe that this will add an extra layer of excitement and value for our holders.

                  Our goal is to make it easier for people to access the products they want in a convenient and transparent way. With the use of smart vending machines and a decentralized voting system, we hope to bring CBD/THC and web3 closer together and provide a unique and innovative way for people to purchase the products they need.
                </p>

              </div>

            </div>

            <img className="cloud-border cloud-border--bottom" src="images/cloud_border.png" alt="a cloud that borders the preceding text" />
            <img className="cloud-border cloud-border-long--bottom" src="images/cloud_border-long.png" alt="a cloud that borders the preceding text" />
          </div>

        </section>

        {/* <!--==================== ROADMAP SECTION ====================--> */}
        <section className="roadmap__section" id="roadmap__section-id">

          <div className="section_heading-cloud bounce center" id="roadmap">
            <img src="images/mapCloud.png" alt="a floating cloud of text that says roadmap" />
          </div>

          <div className="roadmap__container">

            <div>
              <img className="map__image" src="images/roadmap_transparent.png"
                alt="little stonies roadmap describing a timeline of events" />
            </div>

          </div>

        </section>


        {/* <!--==================== COIN SECTION ====================--> */}

        <section className="coin__section" id="coin__section-id">

          <div className="coin_border-cloud-top"></div>

          <div className="coin__container coin-tripple-border">

            <div className="copy__container">

              <div className="coin__copy">


                <div className="coin__list-container grid">
                  <h1 className="coin__heading">$STNIE</h1>
                  <p className="coin__subheading">To be able to grasp how good our token is, you need to understand how it works!</p>


                  <Fade left duration={2000}><img src="images/coin.png" className="grid__image token__image" alt="a little stonies token" /></Fade>


                  <ul className="coin__list token">
                    <div className="coin__list-chunk">
                      <li className="coin__list-header">Toke-enomics</li>
                      <ul className="coin__list-nested">
                        <li className="coin__list-item">Grants access to our classified premium sub-collection</li>
                        <li className="coin__list-item">Redeemable at Little Stonies smart vending machines</li>
                        <li className="coin__list-item">Exchange tokens for Discord channel points</li>
                        <li className="coin__list-item">Patreon exclusives!</li>
                      </ul>
                    </div>
                  </ul>


                  <ul className="coin__list supply">
                    <div className="coin__list-chunk">
                      <li className="coin__list-header">Supply</li>
                      <ul className="coin__list-nested">
                        <li className="coin__list-item">The maximum supply of $STNIE is 300,000,000</li>
                        <li className="coin__list-item">There will be 3 halving periods which will cut the mining rewards by 50% </li>
                        <li className="coin__list-item">Period 1: 150,000,000. Period 2: 225,000,000. Period 3: 270,000,000</li>
                      </ul>
                    </div>
                  </ul>

                  <Fade right duration={2000}><img src="images/pyramid.png" className="grid__image supply__image" alt="a pyramid depicting the max supply of $STNIE" /></Fade>

                  <Fade left duration={2000}><img src="images/free.png" className="grid__image nft__image" alt="" /></Fade>

                  <ul className="coin__list nft">
                    <div className="coin__list-chunk">
                      <li className="coin__list-header">Stonie NFT</li>
                      <ul className="coin__list-nested">
                        <li className="coin__list-item">Wavy! I mean just look at these li'l guys!</li>
                        <li className="coin__list-item">Stake your Genesis Little Stonie to yield 15 $STNIE a day</li>
                        <li className="coin__list-item">Use them for discounted purchases at any of our retail locations!</li>
                      </ul>
                    </div>
                  </ul>


                </div>

              </div>

            </div>

            <div className="ball"></div>
            <div className="ball b2"></div>
            <div className="ball b3"></div>
            <div className="ball b4"></div>
            <div className="ball b5"></div>

          </div>

          <div className="coin__holder-cloud-top"></div>
          <div className="coin__cloud-stuffing">.</div>
          <div className="coin__holder-cloud-bottom"></div>

        </section>



        {/* <!--==================== UTILITIES SECTION ====================--> */}

        <section className="utilities__section" id="utilities__section-id">
          <section className="section">
            <h2 className="utilities__header">Utilities</h2>
            <span className="utilities__subheader">What can $STNIE be used for?</span>

            <div className="utilities__container container grid">

              <Fade top duration={1000}>
                <div className="utilities__card utilities-tripple-border">
                  <Icon className="leaf" path={mdiCannabis} size={1.5} />

                  <h2 className="utilities__title">
                    Coming Soon!
                  </h2>

                  <p className="utilities__description">
                    ???<br />
                    But Wait! There's more! We'll be adding additional utilites. Don't want to miss out?
                  </p>
                </div>
              </Fade>

              <Fade top duration={2000}>
                <div className="utilities__card utilities-tripple-border">
                  <Icon className="leaf" path={mdiCannabis} size={1.5} />

                  <h2 className="utilities__title">
                    Coming Soon!
                  </h2>

                  <p className="utilities__description">
                    ??? <br />
                    We encourague you to stay active in the community. Check Discord often!
                  </p>

                </div>
              </Fade>


              <Fade top duration={3000}>
                <div className="utilities__card utilities-tripple-border">
                  <Icon className="leaf" path={mdiCannabis} size={1.5} />

                  <h2 className="utilities__title">
                    Coming Soon!
                  </h2>

                  <p className="utilities__description">
                    ??? <br />
                    Keep your head in the clouds, or see your opportunity go up in smoke!
                  </p>

                </div>
              </Fade>
            </div>
          </section>


        </section>


        {/* * <!--==================== TEAM SECTION ====================--> */}

        <section className="team__section" id="team__section-id">

          <div className="section_heading-cloud bounce center" id="team">
            <img src="images/teamCloud.png" alt="a floating cloud of text that says team" />
          </div>

          <div className="team__container">

            <div className="member__row">

              <div className="member__container">
                <div className="member__content">
                  <div className="member__imageContainer zoom">
                    <a href='https://twitter.com/StanTheStonie' target='blank'> <img className="member__image" src="images/Stan.png"
                      alt="a purple stonie avatar for the team member Stan" /></a>
                  </div>
                  <div className="description__container">
                    <h3 className="member__name"> *Stan</h3>
                    <h4 className="member__title">Co-Founder / Web3 Dev</h4>
                    <p className="member__description"> The man with the plan
                    </p>
                  </div>
                </div>
              </div>

              <div className="member__container">
                <div className="member__content">
                  <div className="member__imageContainer zoom">
                    <a href='https://twitter.com/M4CKTHESTONI3' target='blank'><img className="member__image" src="images/mack.png"
                      alt="a purple stonie avatar for the team member mack" /></a>
                  </div>
                  <div className="description__container">
                    <h3 className="member__name">!Mack</h3>
                    <h4 className="member__title">Co-Founder / Business Management</h4>
                    <p className="member__description">Our footsoldier and hustler
                    </p>
                  </div>
                </div>
              </div>

              <div className="member__container">
                <div className="member__content">
                  <div className="member__imageContainer zoom">
                    <a href='https://www.instagram.com/valestrator/' target='blank'><img className="member__image" src="images/artist_icon.png"
                      alt="a green stonie avatar for the artist Val" /></a>
                  </div>
                  <div className="description__container">
                    <h3 className="member__name">Valestrator</h3>
                    <h4 className="member__title">Artist</h4>
                    <p className="member__description">The wavy ass designer behind Little Stonies
                    </p>
                  </div>
                </div>
              </div>

              <div className="member__container">
                <div className="member__content">
                  <div className="member__imageContainer zoom">
                    <img className="member__image" src="images/Obi.png" alt="a pink stonie avatar for the team member obi" />
                  </div>
                  <div className="description__container">
                    <h3 className="member__name">Obi</h3>
                    <h4 className="member__title">Front-End Dev</h4>
                    <p className="member__description">Developer extraordinaire! Built our site from the ground up
                    </p>
                  </div>
                </div>
              </div>

              <div className="member__container">
                <div className="member__content">
                  <div className="member__imageContainer zoom">
                    <a href='https://twitter.com/0xtlop' target='blank'><img className="member__image" src="images/flanders.png" alt="" /></a>
                  </div>
                  <div className="description__container">
                    <h3 className="member__name"> Tlop</h3>
                    <h4 className="member__title">Community management</h4>
                    <p className="member__description">Web3 trader (Crypto and NFT's)
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://little-stonies.gitbook.io/little-stonies/introduction/the-team" target="blank" className="button">
                Want to know more?
              </a>


            </div>



          </div>
        </section>

        <div className="transition__container" >
          <img src="images/right_transition_transparent.png" alt="four little stonies walking on clouds to the F A Q section"
            className="transition" />
        </div>

        {/* <!--==================== FAQ SECTION ====================--> */}

        <section className="faq__section" id="faq__section-id">


          <div className="accordion__container">

            <div className="section_heading-cloud bounce small" id="faq">
              <img src="images/faqCloud.png"
                alt="a floating cloud of text that denotes the Frequently asked questions section" />
            </div>

            <div className="accordion__item">

              <div className="accordion_item-header">
                What is the supply?
              </div>
              <div className="accordion__item-body">
                <div className="accordion__item-body-content">
                  Our collection size is 4,200
                </div>
              </div>
            </div>

            <div className="accordion__item">
              <div className="accordion_item-header">
                Where is your whitepaper?
              </div>
              <div className="accordion__item-body">
                <div className="accordion__item-body-content">
                  Right here: <a href="https://little-stonies.gitbook.io/little-stonies/" target="blank"> Rolling papers</a>
                </div>
              </div>
            </div>

            <div className="accordion__item">
              <div className="accordion_item-header">
                DAO?
              </div>
              <div className="accordion__item-body">
                <div className="accordion__item-body-content">
                  A DAO, or Decentralized Autonomous Organization, is a digital organization that is run by a set of rules encoded as computer programs on a blockchain network. These rules dictate how the organization functions and how decisions are made, allowing for decentralized decision-making and self-governance. Transactions and operations within a DAO are validated by consensus among its members. DAOs are often created to manage decentralized projects or communities, and can be thought of as a digital version of a traditional corporation or non-profit organization.
                </div>
              </div>
            </div>

            <div className="accordion__item">
              <div className="accordion_item-header">
                Public Sale?
              </div>
              <div className="accordion__item-body">
                <div className="accordion__item-body-content">
                  We will make sure to reserve some spots to allow newcomers a chance at joining our family. We know not everyone can participate as much as they would like due to work, school or family so we want to make sure you know we care &#60;3
                </div>
              </div>
            </div>

            <div className="accordion__item">
              <div className="accordion_item-header">
                Utility?
              </div>
              <div className="accordion__item-body">
                <div className="accordion__item-body-content">
                  You can look at all current utilities here: <a href="https://little-stonies.gitbook.io/little-stonies/utilities/grounded-utilities" target="blank"> Utilities </a>
                </div>
              </div>
            </div>

          </div>

        </section>
      </main>

    </div>
  )
}

export default Landing;